/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { RapportPreposeDto } from '../models/rapport-prepose-dto';


/**
 * Fonctions de gestion des rapports des préposés
 */
@Injectable({
  providedIn: 'root',
})
export class RapportsPreposesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation rapportPreposeGetList
   */
  static readonly RapportPreposeGetListPath = '/api/rapports-preposes/list';

  /**
   * Renvoie la liste des rapports des préposés.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportPreposeGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportPreposeGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<RapportPreposeDto>>> {

    const rb = new RequestBuilder(this.rootUrl, RapportsPreposesService.RapportPreposeGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RapportPreposeDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des rapports des préposés.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportPreposeGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportPreposeGetList(params?: {
  }): Observable<Array<RapportPreposeDto>> {

    return this.rapportPreposeGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<RapportPreposeDto>>) => r.body as Array<RapportPreposeDto>)
    );
  }

  /**
   * Path part for operation rapportPreposeLoadList
   */
  static readonly RapportPreposeLoadListPath = '/api/rapports-preposes/load-list';

  /**
   * Renvoie la liste des rapports des préposés (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportPreposeLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportPreposeLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, RapportsPreposesService.RapportPreposeLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des rapports des préposés (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportPreposeLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportPreposeLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.rapportPreposeLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation rapportPreposeGet
   */
  static readonly RapportPreposeGetPath = '/api/rapports-preposes/{id}';

  /**
   * Renvoie le rapport d'un préposé spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportPreposeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportPreposeGet$Response(params: {

    /**
     * Identifiant du rapport d&#x27;un préposé
     */
    id: number;
  }): Observable<StrictHttpResponse<RapportPreposeDto>> {

    const rb = new RequestBuilder(this.rootUrl, RapportsPreposesService.RapportPreposeGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RapportPreposeDto>;
      })
    );
  }

  /**
   * Renvoie le rapport d'un préposé spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportPreposeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportPreposeGet(params: {

    /**
     * Identifiant du rapport d&#x27;un préposé
     */
    id: number;
  }): Observable<RapportPreposeDto> {

    return this.rapportPreposeGet$Response(params).pipe(
      map((r: StrictHttpResponse<RapportPreposeDto>) => r.body as RapportPreposeDto)
    );
  }

  /**
   * Path part for operation rapportPreposePut
   */
  static readonly RapportPreposePutPath = '/api/rapports-preposes/{id}';

  /**
   * Met à jour le rapport d'un préposé spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportPreposePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportPreposePut$Response(params: {

    /**
     * Identifiant du rapport d&#x27;un préposé à mettre à jour
     */
    id: number;

    /**
     * Rapport d'un préposé
     */
    body: RapportPreposeDto
  }): Observable<StrictHttpResponse<RapportPreposeDto>> {

    const rb = new RequestBuilder(this.rootUrl, RapportsPreposesService.RapportPreposePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RapportPreposeDto>;
      })
    );
  }

  /**
   * Met à jour le rapport d'un préposé spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportPreposePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportPreposePut(params: {

    /**
     * Identifiant du rapport d&#x27;un préposé à mettre à jour
     */
    id: number;

    /**
     * Rapport d'un préposé
     */
    body: RapportPreposeDto
  }): Observable<RapportPreposeDto> {

    return this.rapportPreposePut$Response(params).pipe(
      map((r: StrictHttpResponse<RapportPreposeDto>) => r.body as RapportPreposeDto)
    );
  }

  /**
   * Path part for operation rapportPreposeDelete
   */
  static readonly RapportPreposeDeletePath = '/api/rapports-preposes/{id}';

  /**
   * Supprime le rapport d'un préposé spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportPreposeDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportPreposeDelete$Response(params: {

    /**
     * Identifiant du rapport d&#x27;un préposé à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, RapportsPreposesService.RapportPreposeDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le rapport d'un préposé spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportPreposeDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportPreposeDelete(params: {

    /**
     * Identifiant du rapport d&#x27;un préposé à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.rapportPreposeDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation rapportPreposePost
   */
  static readonly RapportPreposePostPath = '/api/rapports-preposes';

  /**
   * Crée le rapport d'un préposé spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportPreposePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportPreposePost$Response(params: {

    /**
     * Rapport d'un préposé
     */
    body: RapportPreposeDto
  }): Observable<StrictHttpResponse<RapportPreposeDto>> {

    const rb = new RequestBuilder(this.rootUrl, RapportsPreposesService.RapportPreposePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RapportPreposeDto>;
      })
    );
  }

  /**
   * Crée le rapport d'un préposé spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportPreposePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportPreposePost(params: {

    /**
     * Rapport d'un préposé
     */
    body: RapportPreposeDto
  }): Observable<RapportPreposeDto> {

    return this.rapportPreposePost$Response(params).pipe(
      map((r: StrictHttpResponse<RapportPreposeDto>) => r.body as RapportPreposeDto)
    );
  }

}
